export const resources = {
  resourcesFolderInfoText: 'Fil(er)',
  resourcesItemInfoLastUpdText: 'Senast uppdaterad',
  resourcesItemInfoUploadedText: 'Uppladdad',
  resourcesSearchInputText: 'Sök',
  resourcesUserActionSheetOptionTitle: 'Kopiera länk',
  resourcesActionCopiedAlertText: 'Länk kopierad!',
  resourcesOwnersCurtainEditOptionText: 'Redigera titel',
  resourcesOwnersCurtainDeleteOptionText: 'Ta bort',
  resourcesOwnerCurtainHideOptionText: 'Dölj (Inaktiv)',
  resourcesEditPopupTitle: 'Redigera titel',
  resourcesEditPopupResetButtonTitle: 'Återställ',
  resourcesEditPopupApplyButtonTitle: 'Verkställ',
  resourcesItemEditedAlertText: 'Objektet har uppdaterats!',
  resourcesHidePopupTitle: 'Dölj',
  resourcesHidePopupText: 'Vill du dölja detta objekt?',
  resourcesHidePopupCancelButtonTitle: 'Avbryt',
  resourcesHidePopupConfirmButtonTitle: 'Bekräfta',
  resourcesDeletePopupTitle: 'Ta bort',
  resourcesDeletePopupText: 'Vill du ta bort detta objekt?',
  resourcesDeletePopupCancelButtonTitle: 'Avbryt',
  resourcesDeletePopupConfirmButtonTitle: 'Bekräfta',
  resourcesItemDeletedAlertText: 'Objektet har tagits bort!',
  resourceDetailsLinkText: 'Detta är en extern URL och kommer att öppnas i ett nytt fönster. Öppna?',
  resourceDetailsLinkOpenButtonTitle: 'Öppna',
  resourceDetailsLinkOpenAgainButtonTitle: 'Öppna igen',
  resourceDetailsLinkCopyURLButtonTitle: 'Kopiera mållänk',
  resourceDetailsLinkCopiedURLAlertText: 'URL kopierad!',
  resurceDetailsLinkCurtainOptionCopyText: 'Kopiera länk',
  resourceDetailsFileInfoLastUpdText: 'Senast uppdaterad',
  resourceDetailsFileInfoUploadText: 'Uppladdad',
  resourceDetailsFileSaveButtonTitle: 'Öppna',
  resourceDetailsFileCopyButtonTitle: 'Kopiera länk',
  resourcesOwnersCurtainCopyOptionText: 'Kopiera länk',
  resourceDetailsFileLoadingText: 'Laddar...',
  resourceDetailsImageCurtainCopyOptionText: 'Kopiera länk',
  resourceDetailsImageCurtainDownloadOptionText: 'Ladda ner',
  resourceFolder: 'Mapp',
  resourceAdded: 'Tillagt'
}
